import { Box, Radio } from '@factorialco/deprecated-design-system'

import { useFormContext } from 'modules/core/hooks/useForm'

import { WorkingConditionDisplayItemProps } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { getI18nItemFieldKey } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { WorkConditionVersionItemsFormData } from 'modules/contracts_settings/pages/WorkingConditionsVersionPage/forms'

const CategoricalDataItem = ({
  name,
  allowedValues,
  default: defaultValue,
}: WorkingConditionDisplayItemProps) => {
  const form = useFormContext<WorkConditionVersionItemsFormData>()

  return (
    <Box gap="s6">
      {allowedValues?.map((value) => (
        <Radio
          key={`${name}.${value}`}
          description={getI18nItemFieldKey(`${name}.${value}`, 'description')}
          name={name}
          option={{
            disabled: false,
            label: getI18nItemFieldKey(`${name}.${value}`, 'label'),
            value: value,
          }}
          value={form.values.items[name] || defaultValue || ''}
          onChange={(newValue) => form.setFieldValue('items.' + name, newValue)}
        />
      ))}
    </Box>
  )
}

export default CategoricalDataItem
